export default __webpack_public_path__ + "4ab7a0751e1b3da2669cb3fe0ba49280.svg";